import React from 'react';
import CompanyCategoriesComponent from '../../../components/company-categories';

const CompanyCategories = () => (
  <CompanyCategoriesComponent/>
);

export default CompanyCategories;
